<template>
  <div class="protocal-con">
    <div v-for="(item, index) in content" :key="index">
      <p class="title">{{ item.title }}</p>
      <p class="text">{{ item.text }}</p>
    </div>
  </div>
</template>

<script>
  import { bridge } from 'mixins'

  export default {
    name: "YxlCoinInstructions",
    mixins: [bridge],
    data() {
      return {
        content: [
          {
            title: '1. 什么是鲸币？',
            text: '鲸币是壹心理平台用户消费的虚拟币，目前可以在直播期间用于购买礼物，给心仪的主播送礼。'
          },
          {
            title: '2. 如何获得鲸币？',
            text: '可以在鲸币管理中心、直播间打赏模块上进行充值获得鲸币。'
          }
        ]
      }
    },
    mounted() {
      this.setNavTitle('鲸币说明')
    }
  }
</script>

<style lang="scss" scoped>
  .protocal-con {
    padding: 0 48px;
    min-height: 100vh;
    background-color: #fff;
  }

  .title {
    padding: 48px 0 30px;
    font-family: PingFangSC-Medium;
    font-size: 32px;
    color: #21252D;
    font-weight: bold;
  }

  .text {
    font-family: PingFangSC-Regular;
    font-size: 26px;
    color: #4C5463;
  }
</style>
